// extracted by mini-css-extract-plugin
export default {"container":"DashboardPage_container__3cUIP","grid":"DashboardPage_grid__dFIvK","right":"DashboardPage_right__Uitmz"};